// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["extensions/slider/ken-burns/style-view"], () => (__webpack_require__("./src/extensions/slider/ken-burns/view.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
